module.exports = __webpack_public_path__ + "static/media/pinterest-grey.a1d7a8ab.svg";